import React from 'react';

export function SplashScreen() {
  const themePref = localStorage.getItem('forxa-theme-preference') ?? 'dark';
  const prefersDark = typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const isDark = themePref === 'dark' || (themePref === 'system' && prefersDark);
  const language = (localStorage.getItem('forxa-language') ?? 'en') === 'es' ? 'es' : 'en';

  const bg = isDark ? '#07131C' : '#F0EDE8';
  const cardBg = isDark ? '#122538' : '#E4E0DA';
  const cardBg2 = isDark ? '#0D1F2D' : '#EAE6E0';
  const centerBg = isDark ? '#07131C' : '#F0EDE8';
  const textColor = isDark ? '#F1F5F9' : '#1E2A34';
  const gridColor = isDark ? 'rgba(255,255,255,0.025)' : 'rgba(0,0,0,0.04)';
  const labelColor = isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)';

  return (
    <div className="fixed inset-0 flex flex-col z-50 overflow-hidden" style={{ background: bg }}>
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            `repeating-linear-gradient(0deg,transparent 0 39px,${gridColor} 39px 40px),` +
            `repeating-linear-gradient(90deg,transparent 0 39px,${gridColor} 39px 40px)`,
        }}
      />

      <div className="relative z-10 pt-10 pl-10 flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full" style={{ background: '#F97316' }} />
        <span className="text-xs font-semibold tracking-[0.22em] uppercase" style={{ color: labelColor }}>
          {language === 'es' ? '// Estado de carga - Inicializando' : '// Loading state - Initializing'}
        </span>
      </div>

      <div className="relative z-10 flex-1 flex flex-col items-center justify-center gap-8">
        <div
          style={{
            width: 110,
            height: 110,
            animation: 'forxa-spin 1.6s linear infinite',
          }}
        >
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
            <g transform="translate(100 100) rotate(45)">
              <rect x="-84" y="-21" width="168" height="42" rx="6" fill="#F97316" />
              <rect x="-84" y="-21" width="8" height="42" fill="#0D1F2D" opacity="0.2" />
              <rect x="76" y="-21" width="8" height="42" fill="#0D1F2D" opacity="0.2" />
            </g>
            <g transform="translate(100 100) rotate(-45)">
              <rect x="-84" y="-21" width="168" height="42" rx="6" fill="#F97316" />
              <rect x="-84" y="-21" width="8" height="42" fill="#0D1F2D" opacity="0.2" />
              <rect x="76" y="-21" width="8" height="42" fill="#0D1F2D" opacity="0.2" />
            </g>
            <circle cx="100" cy="100" r="9" fill={centerBg} />
            <circle cx="100" cy="100" r="4" fill="#F97316" />
          </svg>
        </div>

        <p className="font-bold tracking-[0.2em] uppercase text-sm" style={{ color: textColor }}>
          {language === 'es' ? 'Cargando ' : 'Loading '}
          <span style={{ color: '#F97316' }}>{language === 'es' ? 'obra...' : 'Jobsite...'}</span>
        </p>
      </div>

      <div className="relative z-10 pb-16 px-10 space-y-4 max-w-2xl w-full mx-auto">
        {[85, 55, 70].map((w, i) => (
          <div key={i} className="flex items-center gap-4">
            <div
              className="rounded-lg flex-shrink-0"
              style={{
                width: 40,
                height: 40,
                background: cardBg,
                animation: `forxa-shimmer 1.6s ease-in-out ${i * 0.15}s infinite`,
              }}
            />
            <div className="flex-1 space-y-2">
              <div
                className="rounded"
                style={{
                  height: 10,
                  width: `${w}%`,
                  background: cardBg,
                  animation: `forxa-shimmer 1.6s ease-in-out ${i * 0.15}s infinite`,
                }}
              />
              <div
                className="rounded"
                style={{
                  height: 8,
                  width: `${w - 20}%`,
                  background: cardBg2,
                  animation: `forxa-shimmer 1.6s ease-in-out ${i * 0.15 + 0.1}s infinite`,
                }}
              />
            </div>
            <div
              className="rounded flex-shrink-0"
              style={{
                width: 60,
                height: 10,
                background: cardBg,
                animation: `forxa-shimmer 1.6s ease-in-out ${i * 0.15}s infinite`,
              }}
            />
          </div>
        ))}
      </div>

      <style>{`
        @keyframes forxa-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes forxa-shimmer {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
}
